import { Link } from "gatsby"
import React from "react"
import styled from "@emotion/styled"
import Container from "./container"
import HamburgerMenu from "react-hamburger-menu"
import theme from  "../theme"

const isBrowser = typeof window !== "undefined"
const firebase = isBrowser ? require("firebase/app") : "div"
const auth = isBrowser ? require("firebase/auth") : "div"

const Styles = styled.div`
  background: #c7add9;
  position: fixed;
  z-index: 1;
  top: 0;
  width: 100%;
  height: 80px;

  .home-link {
    font-size: 22px;
    font-weight: 600;
  }
  .links {
    display: none;
    text-align: center;
    z-index: 10000;

    &.active {
      display: block;
      position: absolute;
      width: 100%;
      text-align: center;
      background: #c7add9;
      top: 57px;
      right: 0px;
      padding-top: 12px;
      padding-bottom: 14px;

      div {
        margin-bottom: 12px;
      }
    }

    @media screen and (min-width: ${theme.breakpoints.mid }px) {
      position: relative !important;
      float: right;
      display: grid !important;
      grid-template-columns: repeat(auto-fit, minmax(94px, 1fr));
      max-width: 820px;
      top: 0px !important;
      padding-top: 4px !important;

      div {
        margin-bottom: 0px !important;
      }
    }
  }

  a {
    color: #542c85;
    padding-bottom: 1px;

    &.active {
      border-bottom: 2px solid #ead9ff;
    }
  }

  .hamburger {
    float: right;
    cursor: pointer;
    position: relative;
    top: 8px;
    margin-right: 5px;
    margin-left: 9px;

    @media screen and (min-width: ${theme.breakpoints.mid }px) {
      display: none;
    }
  }

`
export default class Header extends React.Component {
  constructor(props) {
    super()
    this.state = {}
    this.state.path = props.path
    this.state.login = (
      <Link className="my-login" to="/login">
        login
      </Link>
    )
  }

  setUser(user) {
    if (user) {
      this.setState({
        login: (
          <Link className="my-account" to="/account">
            account
          </Link>
        ),
      })
    }

    this.setActive()
  }

  setActive() {
    switch (this.state.path) {
      case "/":
        document.querySelectorAll(".home-link")[0].classList.toggle("active")
        break
      case "program":
        document.querySelectorAll(".my-program")[0].classList.toggle("active")
        break

      case "graduates":
        document.querySelectorAll(".my-graduates")[0].classList.toggle("active")
        break
      case "projects":
        document.querySelectorAll(".my-projects")[0].classList.toggle("active")
        break
      case "snippets":
        document.querySelectorAll(".my-snippets")[0].classList.toggle("active")
        break
      case "courses":
        document.querySelectorAll(".my-courses")[0].classList.toggle("active")
        break
      case "account":
        document.querySelectorAll(".my-account")[0].classList.toggle("active")
        break

      case "about":
        document.querySelectorAll(".my-about")[0].classList.toggle("active")
        break
      case "login":
        document.querySelectorAll(".my-login")[0].classList.toggle("active")
        break

      default:
        break
    }
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(this.setUser.bind(this))
  }

  toggleMenu() {
    document.querySelectorAll(".links")[0].classList.toggle("active")

    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    return (
      <Styles>
          <Container>
            <div className="hamburger">
              <HamburgerMenu
                isOpen={this.state.open}
                menuClicked={this.toggleMenu.bind(this)}
                width={23}
                height={16}
                strokeWidth={2}
                rotate={0}
                color="#542c85"
                borderRadius={0}
                animationDuration={0.001}
              />
            </div>

            <div className="links">

              

              <div>
                <Link className="my-about" to="/about">
                  about
                </Link>
              </div>

              <div>
                <Link className="my-program" to="/program">
                  program
                </Link>
              </div>

              <div>
                <Link className="my-courses" to="/courses">
                  courses
                </Link>
              </div>

              <div>
                <Link className="my-graduates" to="/graduates">
                  graduates
                </Link>
              </div>

              

              <div>
                <Link className="my-snippets" to="/snippets">
                  snippets
                </Link>
              </div>

              


              <div>
                <Link className="my-projects" to="/projects">
                  projects
                </Link>
              </div>

              <div>{this.state.login}</div>
            </div>

            <div className="home-link">
              <Link to="/">gatsby-university</Link>
            </div>
          </Container>
      </Styles>
    )
  }
}
